export const range = (start: number, end: number): number[] => {
    return new Array(end - start + 1).fill(undefined).map((_: number, index: number) => index + start);
};
